import { createAction } from '@reduxjs/toolkit'
import { Role, User } from 'src/types/auth';

export const CREATE_AUTHENICATOR = createAction<{ authenticator: any }>('@auth/CREATE')

export const AUTH_GET_USERS = createAction<{ users: User[] }>("@auth/GET_USERS");
export const AUTH_ADD_USER = createAction<{ user: User }>("@auth/ADD_USER");
export const AUTH_UPDATE_USER = createAction<{ user: User }>("@auth/UPDATE_USER");
export const AUTH_DELETE_USER = createAction<{ userId: string }>("@auth/DELETE_USER");

export const AUTH_GET_ROLES = createAction<{ roles: Role[] }>("@auth/GET_ROLES");
export const AUTH_ADD_ROLE = createAction<{ role: Role }>("@auth/ADD_ROLE");
export const AUTH_UPDATE_ROLE = createAction<{ role: Role }>("@auth/UPDATE_ROLE");
export const AUTH_DELETE_ROLE = createAction<{ roleName: string }>("@auth/DELETE_ROLE");

